import React from 'react';
import { Link } from 'react-aria-components';
import SvgIcon from '../../utils/SvgIcon';
import type { ZipDownloadItem } from '../../../types/downloads';

interface PortalDownloadsProps {
  downloads: ZipDownloadItem[];
  heading?: string;
  expiryNotificationText?: string;
  expiryDateLabel?: string;
}

export default function PortalDownloads({
  downloads,
  heading,
  expiryNotificationText,
  expiryDateLabel,
}: Readonly<PortalDownloadsProps>) {
  if (!downloads || downloads.length === 0) {
    return null;
  }

  return (
    <div className="dashboard-card portal-downloads">
      {heading && <h2 className="portal-downloads__heading">{heading}</h2>}

      <div className="portal-downloads__list">
        {downloads.map((download, index) => (
          <div key={`${download.relativePath}-${index}`} className="portal-downloads__item">
            <div className="portal-downloads__item-info">
              <SvgIcon
                iconName="check-circle-medium"
                additionalClasses="portal-downloads__item-icon"
                aria-hidden="true"
              />
              <div className="portal-downloads__item-details">
                <p className="portal-downloads__item-label">{download.displayLabel}</p>
                <p className="portal-downloads__item-expiry">
                  {expiryDateLabel}: {download.expirtyDateFormatted}
                </p>
              </div>
            </div>
            <Link href={download.relativePath} className="portal-downloads__item-btn cta cta--primary" download>
              <SvgIcon
                iconName="download-medium"
                additionalClasses="portal-downloads__item-btn-icon"
                aria-hidden="true"
              />
            </Link>
          </div>
        ))}
      </div>

      {expiryNotificationText && <p className="portal-downloads__expiry-note">{expiryNotificationText}</p>}
    </div>
  );
}
